import { Input, Select } from 'antd';
import { Search, Store } from 'lucide-react';

import { useI18n } from '../../i18n';

export const SearchInput = ({ value, onChange, placeholder, className = '', autoFocus }) => (
  <Input
    allowClear
    autoFocus={autoFocus}
    className={`wm-search-input ${className}`}
    prefix={<Search size={15} strokeWidth={1.75} />}
    placeholder={placeholder}
    value={value}
    onChange={e => onChange(e.target.value)}
  />
);

export const BranchSelect = ({ branches, value, onChange, loading, includeAll = true, style }) => {
  const { t } = useI18n();
  const options = [
    ...(includeAll ? [{ value: 0, label: t('filters.allBranches') }] : []),
    ...(branches ?? []).map(branch => ({ value: branch.id, label: branch.name })),
  ];
  return (
    <Select
      showSearch
      optionFilterProp='label'
      loading={loading}
      value={loading ? undefined : value}
      onChange={onChange}
      options={options}
      placeholder={t('filters.branch')}
      suffixIcon={<Store size={15} strokeWidth={1.75} />}
      style={{ minWidth: 200, ...style }}
      popupMatchSelectWidth={false}
    />
  );
};
